import { inject, Injectable, signal } from '@angular/core';
import { IRecall } from '@core/interface';
import { MockService } from '../mock-service/mock.service';

@Injectable({
  providedIn: 'root',
})
export class RecallService {

    readonly #mockService = inject(MockService);

    availableRecalls = signal<IRecall[] | null>(null);

    setRecalls(recalls: IRecall[]): void {
        if(recalls.length > 0) {
            this.availableRecalls.set(recalls);
            this.#mockService.recalls.set(recalls); // TODO: Trocar pelo selectedServices quando existir
            sessionStorage.setItem('recalls', JSON.stringify(recalls));
        }
    }
}